angular
  .module('cfn')
  .factory('plantProtectantModuleConnector', PlantProtectantModuleConnector);

PlantProtectantModuleConnector.$inject = ['$resource'];

var source;

function PlantProtectantModuleConnector($resource) {
  return function() {
    if (source !== undefined) {
      return source;
    }

    var resourceDef = {
      listForSearch: {
        method: 'GET',
        isArray: true,
        params: {
          restAction: 'listForSearch'
        }
      }
    };

    var restService = $resource(
      '/365FarmNet/mod/catalog/rest/v1.0/plantProtectants/:restAction',
      {},
      resourceDef
    );

    source = {
      /**
       * @returns {Resource} Resource api to the model service
       */
      getRestService: function() {
        return restService;
      },
      /**
       * @returns {promise} a promise with the retrieved results
       */
      getList: function(customResourceExtend) {
        return restService.listForSearch().$promise;
      }
    };
    return source;
  };
}

export default PlantProtectantModuleConnector;
